import * as React from 'react';
import { Component, ReactNode, Suspense, lazy } from 'react';

import { interiorStore } from '../../store/stores/interior-store';
import { LoadingSpinner } from '../loading-spinner';

const InteriorView360 = lazy(async () => import(/* webpackChunkName: "interior" */ './interior-view-360'));

class InteriorErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
	state = { hasError: false };

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error: unknown) {
		console.error('[Visualizer] Failed to load interior view', error);
		interiorStore.isInteriorLoaded.set(false);
	}

	render() {
		return this.state.hasError ? null : this.props.children;
	}
}

export default function InteriorRender() {
	return (
		<InteriorErrorBoundary>
			<Suspense fallback={<LoadingSpinner />}>
				<InteriorView360 />
			</Suspense>
		</InteriorErrorBoundary>
	);
}
